import { styled } from "@mui/material"

export const StyledButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
`
